import { render, staticRenderFns } from "./CAJG1080.vue?vue&type=template&id=a8dfc46a&scoped=true"
import script from "./CAJG1080Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAJG1080Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAJG1080.vue?vue&type=style&index=0&id=a8dfc46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dfc46a",
  null
  
)

export default component.exports